/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Preset_Manager_Delete_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Preset \"{name}\" deleted successfully" |
*
* @param {Preset_Manager_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_delete_success_toast = /** @type {((inputs: Preset_Manager_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Preset "${i?.name}" supprime avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" erfolgreich gelöscht`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" eliminata correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предварительно заданные параметры "${i?.name}" успешно удалены.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Preset "${i?.name}" eliminado exitosamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`预设“${i?.name}”已成功删除`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プリセット「${i?.name}」が正常に削除されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" सफलतापूर्वक हटा दिया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" excluída com sucesso`)
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" deleted successfully`)
});